import IconDashboard from "../assets/images/navigation/dashboard.svg?react";
import IconResponsibleAdults from "../assets/images/navigation/responsibleAdults.svg?react";
import IconStudentDetails from "../assets/images/navigation/studentDetails.svg?react";
import IconEnrolmentAgreement from "../assets/images/navigation/enrolmentAgreement.svg?react";
import IconPreviousEducation from "../assets/images/navigation/previousEducation.svg?react";
import IconConsultationCall from "../assets/images/navigation/consultationCall.svg?react";
import IconCourseSelection from "../assets/images/navigation/courseSelection.svg?react";
import IconTuitionBilling from "../assets/images/navigation/tuitionBilling.svg?react";
import IconCommunity from "../assets/images/navigation/community.svg?react";
import IconAcademic from "../assets/images/navigation/academic.svg?react";
import IconFinance from "../assets/images/navigation/finance.svg?react";
import IconSupportingLearning from "../assets/images/navigation/supporting-learning.svg?react";
import IconRenewals from "../assets/images/navigation/renewals.svg?react";
import IconAlumni from "../assets/images/navigation/alumni.svg?react";
import IconExamsInfo from "../assets/images/navigation/exams-info.svg?react";
import { isVersionUS } from "../services/versionService";
import { STUDENT_STATUS } from "../constants/student.status";

export const hiddenForUSFullTime = [
    "consultationCall",
    "courseSelection",
];

const APPLICANT_NAVIGATION = [
    {
        key: "dashboard",
        icon: IconDashboard,
        titleKey: "dashboard",
        link: "/dashboard",
        order: 1,
        requiredId: true,
    },
    {
        key: "responsibleAdults",
        icon: IconResponsibleAdults,
        titleKey: "responsibleAdults",
        link: "/responsible-adults",
        order: 2,
        requiredId: true,
    },
    {
        key: "studentDetails",
        icon: IconStudentDetails,
        titleKey: "studentDetails",
        link: "/student-details",
        order: 3,
        requiredId: true,
    },
    {
        key: "previousEducation",
        icon: IconPreviousEducation,
        titleKey: "previousEducation",
        link: "/previous-education",
        order: 4,
        requiredId: true,
    },
    {
        key: "enrolmentAgreement",
        icon: IconEnrolmentAgreement,
        titleKey: "enrolmentAgreement",
        link: "/enrolment-agreement",
        order: isVersionUS ? 5 : 6,
        requiredId: true,
    },
    {
        key: "consultationCall",
        icon: IconConsultationCall,
        titleKey: "consultationCall",
        link: "/consultation-call",
        order: isVersionUS ? 6 : 5,
        requiredId: true,
    },
    {
        key: "courseSelection",
        icon: IconCourseSelection,
        titleKey: "courseSelection",
        link: "/course-selection",
        order: 7,
        requiredId: true,
    },
    {
        key: "tuitionBilling",
        icon: IconTuitionBilling,
        titleKey: "tuitionBilling",
        link: "/tuition-billing",
        order: 8,
        requiredId: true,
    },
];
const STUDENT_NAVIGATION = [
    {
        key: "home",
        icon: IconDashboard,
        titleKey: "home",
        link: "/home",
        requiredId: true,
    },
    // {
    //     key: "student-hub",
    //     icon: IconStudentHub,
    //     titleKey: "studentHub",
    //     link: "/student-hub",
    // },
    {
        key: "community",
        icon: IconCommunity,
        titleKey: "community",
        link: "/community",
        requiredId: true,
    },
    {
        key: "academic",
        icon: IconAcademic,
        titleKey: "academic",
        link: "/academic",
        requiredId: true,
    },
    {
        key: "supporting-learning",
        icon: IconSupportingLearning,
        titleKey: "supportingLearning",
        link: "/supporting-learning",
        requiredId: true,
    },
    {
        key: "finance",
        icon: IconFinance,
        titleKey: "finance",
        link: "/finance",
        requiredId: true,
    },
    {
        key: "renewals",
        icon: IconRenewals,
        titleKey: "renewals",
        link: "/renewals",
        requiredId: true,
    },
    {
        key: "mentor-pathway",
        icon: IconDashboard,
        titleKey: "mentorPathway",
        link: "/mentor-pathway",
        requiredId: true,
    },
];
export const BASE_DASHBOARD_NAV_ITEM = {
    key: "home",
    icon: IconDashboard,
    titleKey: "home",
    link: "/",
    strictActive: true,
};
export const ALUMNI_NAV_ITEM = {
    key: "alumni",
    icon: IconAlumni,
    titleKey: "alumni",
    link: "/alumni",
};
export const EXAMS_INFO_NAV_ITEM = {
    key: "exams-information",
    icon: IconExamsInfo,
    titleKey: "examsInformation",
    link: "/exams-information",
};

export const navigationHelper = {
    getNavigation: (
        studentStatus,
        isLockedStatus = {},
        hideConsultationCall = false,
        hideSubjectSelectionUS = false,
        hideFinanceItem = false,
        showRenewal = false,
        hideMentorPathway = false,
        isAlumniOverallPage = false,
    ) => {
        if (studentStatus === "ALUMNI" || studentStatus === STUDENT_STATUS.STUDENT) {
            return STUDENT_NAVIGATION
                .filter((item) => (hideFinanceItem ? item.key !== "finance" : true))
                .filter((item) => (!showRenewal ? item.key !== "renewals" : true))
                .filter((item) => (hideMentorPathway ? item.key !== "mentor-pathway" : true));
        }

        let navigation = APPLICANT_NAVIGATION.map((item) => ({
            ...item,
            disabled: !["responsibleAdults", "studentDetails", "previousEducation"].includes(item.key) ? isLockedStatus[item.key] : false,
        }));
        if (hideConsultationCall) {
            navigation = navigation.filter((item) => item.key !== "consultationCall");
        }

        if (!isVersionUS) {
            navigation = navigation.filter((item) => item.key !== "courseSelection");
        }

        if (hideSubjectSelectionUS) {
            navigation = navigation.filter((item) => !hiddenForUSFullTime.includes(item.key));
        }

        if (!studentStatus) navigation = [BASE_DASHBOARD_NAV_ITEM];

        const sortedNavigation = navigation.toSorted((a, b) => a.order - b.order);

        if (!isAlumniOverallPage && !studentStatus) {
            return sortedNavigation.map((item) => ({ ...item, disabled: true }));
        }

        return sortedNavigation;
    },
};
